import React from 'react';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useEventState,
  useEventActions,
} from './EventContext';

import {
  hourForTwelveHourClock,
  meridiemIndicatorForHour,
  formattedMinute,
} from '../../Shared/timeHelpers';

import styles from './EventBreakdown.module.scss';

const EventBreakdown = () => {
  const state = useEventState();
  const {
    updateNewEventBreakdownItemStartDate,
    updateNewEventBreakdownItemEndDate,
    updateNewEventBreakdownItemStartTime,
    updateNewEventBreakdownItemEndTime,
    updateNewEventBreakdownItemDescription,
    addNewEventBreakdownItem,
  } = useEventActions();

  const updateNewBreakdownItemStartDay = (e) => {
    const [startYear, startMonth, startDay] = e.target.value.split("-");
    updateNewEventBreakdownItemStartDate(startYear, startMonth, startDay);
  };

  const updateNewBreakdownItemEndDay = (e) => {
    const [endYear, endMonth, endDay] = e.target.value.split("-");
    updateNewEventBreakdownItemEndDate(endYear, endMonth, endDay);
  };

  const updateNewBreakdownItemStartTime = (e) => {
    const [startHour, startMinute] = e.target.value.split(":");
    updateNewEventBreakdownItemStartTime(startHour, startMinute);
  };

  const updateNewBreakdownItemEndTime = (e) => {
    const [endHour, endMinute] = e.target.value.split(":");
    updateNewEventBreakdownItemEndTime(endHour, endMinute);
  };

  const presentationMode = () => {
    return state?.loading ? (
      null
    ) : (
      <div className={styles.textContainer}>
        <div id={styles.breakdownContainer}>
          {!!state?.event?.breakdownItems?.length && (
            <h3 className={styles.breakdownHeading}>Event Breakdown:</h3>
          )}
          {(state?.event?.breakdownItems || []).map((breakdownItem, index) => {
            const startTime = `${hourForTwelveHourClock(breakdownItem.startHour)}:${formattedMinute(breakdownItem.startMinute)} ${meridiemIndicatorForHour(breakdownItem.startHour)}`;
            const endTime = `${hourForTwelveHourClock(breakdownItem.endHour)}:${formattedMinute(breakdownItem.endMinute)} ${meridiemIndicatorForHour(breakdownItem.endHour)}`;
            return <p key={index} className={styles.breakdown}>{`${startTime} - ${endTime}: ${breakdownItem.description}`}</p>;
          })}
        </div>
      </div>
    );
  };

  const editMode = () => {
    return (
      <div className={styles.textContainer}>
        <div id={styles.breakdownContainer}>
          <h3 className={styles.breakdownHeading}>Event breakdown:</h3>
          {(state?.event?.breakdownItems || []).map((breakdownItem, index) => {
            const startTime = `${hourForTwelveHourClock(breakdownItem.startHour)}:${formattedMinute(breakdownItem.startMinute)} ${meridiemIndicatorForHour(breakdownItem.startHour)}`;
            const endTime = `${hourForTwelveHourClock(breakdownItem.endHour)}:${formattedMinute(breakdownItem.endMinute)} ${meridiemIndicatorForHour(breakdownItem.endHour)}`;
            return <p key={index} className={styles.breakdown}>{`${startTime} - ${endTime}: ${breakdownItem.description}`}</p>;
          })}
          <Form>
            <Field label="Start Date">
              <Input
                type="date"
                value={`${state?.newEventBreakdownItem?.startYear || ''}-${state?.newEventBreakdownItem?.startMonth || ''}-${state?.newEventBreakdownItem?.startDay || ''}`}
                onChange={updateNewBreakdownItemStartDay}
              />
            </Field>
            <Field label="End Date">
              <Input
                type="date"
                value={`${state?.newEventBreakdownItem?.endYear || ''}-${state?.newEventBreakdownItem?.endMonth || ''}-${state?.newEventBreakdownItem?.endDay || ''}`}
                onChange={updateNewBreakdownItemEndDay}
              />
            </Field>
            <Field label="Start Time">
              <Input
                type="time"
                value={`${state?.newEventBreakdownItem?.startHour || ''}:${state?.newEventBreakdownItem?.startMinute || ''}`}
                onChange={updateNewBreakdownItemStartTime}
              />
            </Field>
            <Field label="End Time">
              <Input
                type="time"
                value={`${state?.newEventBreakdownItem?.endHour || ''}:${state?.newEventBreakdownItem?.endMinute || ''}`}
                onChange={updateNewBreakdownItemEndTime}
              />
            </Field>
            <Field label="Description">
              <Input
                type="text"
                placeholder="Description..."
                value={state?.newEventBreakdownItem?.description || ''}
                onChange={(e) => updateNewEventBreakdownItemDescription(e.target.value)}
              />
            </Field>
            <FormActions>
              <Button
                variant="primary"
                onClick={addNewEventBreakdownItem}
              >
                Add New Breakdown Item
              </Button>
            </FormActions>
          </Form>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.event}>
      {state?.inEditMode ?
        (
          editMode()
        ) : (
          presentationMode()
        )
      }
    </div>
  );
};

export default EventBreakdown;
